import * as PropTypes from 'prop-types';

export const ErrorPropType = PropTypes.shape({
    message: PropTypes.string.isRequired,
    errors: PropTypes.arrayOf(PropTypes.string),
});
